// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutoCapitalizeController from "./auto_capitalize_controller";

application.register("auto-capitalize", AutoCapitalizeController);

import DiceAnimationController from "./dice_animation_controller";

application.register("dice-animation", DiceAnimationController);

import ExpandableContentController from "./expandable_content_controller";

application.register("expandable-content", ExpandableContentController);

import FormChangesController from "./form_changes_controller";

application.register("form-changes", FormChangesController);

import FormController from "./form_controller";

application.register("form", FormController);

import FrameNavigationController from "./frame_navigation_controller";

application.register("frame-navigation", FrameNavigationController);

import GalleryController from "./gallery_controller";

application.register("gallery", GalleryController);

import GroupedItemsController from "./grouped_items_controller";

application.register("grouped-items", GroupedItemsController);

import HelloController from "./hello_controller";

application.register("hello", HelloController);

import HighlightController from "./highlight_controller";

application.register("highlight", HighlightController);

import ImagePreviewController from "./image_preview_controller";

application.register("image-preview", ImagePreviewController);

import ImageUploadController from "./image_upload_controller";

application.register("image-upload", ImageUploadController);

import LinksInputController from "./links_input_controller";

application.register("links-input", LinksInputController);

import ModalController from "./modal_controller";

application.register("modal", ModalController);

import RemovableController from "./removable_controller";

application.register("removable", RemovableController);

import SearchController from "./search_controller";

application.register("search", SearchController);

import SearchableListController from "./searchable_list_controller";

application.register("searchable-list", SearchableListController);

import SlideoverController from "./slideover_controller";

application.register("slideover", SlideoverController);

import SortableController from "./sortable_controller";

application.register("sortable", SortableController);

import TabsController from "./tabs_controller";

application.register("tabs", TabsController);

import ThemeController from "./theme_controller";

application.register("theme", ThemeController);

import ToggleableDeleteController from "./toggleable_delete_controller";

application.register("toggleable-delete", ToggleableDeleteController);

import TomSelectController from "./tom_select_controller";

application.register("tom-select", TomSelectController);

import UppyController from "./uppy_controller";

application.register("uppy", UppyController);

import UseDebounceController from "./use_debounce_controller";
